/* Marcas de la home: avance exclusivamente móvil, conservando el gesto nativo. */
(function () {
  'use strict';
  if (window.__miMarcasAutoplay) return;
  window.__miMarcasAutoplay = true;

  var montadas = new WeakMap();
  var movil = window.matchMedia('(max-width: 767px)');
  var movimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  function montar(seccion) {
    if (montadas.has(seccion)) return;
    var riel = seccion.querySelector('[data-mi-riel]');
    var anterior = seccion.querySelector('[data-mi-marca-anterior]');
    var siguiente = seccion.querySelector('[data-mi-marca-siguiente]');
    if (!riel || !anterior || !siguiente) return;

    var timer = null, visible = !window.IntersectionObserver;
    var pausado = movimiento.matches, interactuando = false;
    var hasta = 0, automaticoHasta = 0, eventos = [];
    function escuchar(nodo, tipo, funcion, opciones) {
      nodo.addEventListener(tipo, funcion, opciones);
      eventos.push(function () { nodo.removeEventListener(tipo, funcion, opciones); });
    }
    function detener() { window.clearTimeout(timer); timer = null; }
    function maximo() { return Math.max(0, riel.scrollWidth - riel.clientWidth); }
    function actualizar() {
      seccion.toggleAttribute('data-mi-marcas-listas', movil.matches && maximo() > 4);
      anterior.disabled = riel.scrollLeft <= 2;
      siguiente.disabled = riel.scrollLeft >= maximo() - 2;
    }
    function programar() {
      detener();
      if (!movil.matches || !visible || pausado || interactuando || document.hidden || !seccion.isConnected || maximo() <= 4) return;
      timer = window.setTimeout(avanzar, Math.max(4500, hasta - Date.now()));
    }
    function mover(direccion, automatico) {
      var primero = riel.children[0], segundo = riel.children[1];
      if (!primero || !segundo) return;
      var paso = segundo.getBoundingClientRect().left - primero.getBoundingClientRect().left;
      var destino = Math.max(0, Math.min(maximo(), riel.scrollLeft + direccion * paso));
      if (automatico && riel.scrollLeft >= maximo() - 4) destino = 0;
      automaticoHasta = automatico ? Date.now() + 1600 : 0;
      riel.scrollTo({ left: destino, behavior: movimiento.matches ? 'auto' : 'smooth' });
    }
    function avanzar() {
      timer = null;
      if (!movil.matches || !visible || pausado || interactuando || document.hidden) return;
      if (!riel.contains(document.activeElement)) mover(1, true);
      programar();
    }
    function pausaManual() {
      if (!movil.matches) return;
      hasta = Date.now() + 8000;
      programar();
    }
    escuchar(anterior, 'click', function () { mover(-1, false); pausaManual(); });
    escuchar(siguiente, 'click', function () { mover(1, false); pausaManual(); });
    escuchar(riel, 'pointerdown', function () {
      if (!movil.matches) return;
      interactuando = true;
      automaticoHasta = 0;
      detener();
    }, { passive: true });
    function soltar() {
      if (!interactuando) return;
      interactuando = false;
      pausaManual();
    }
    escuchar(window, 'pointerup', soltar, { passive: true });
    // El navegador cancela el puntero al asumir el gesto táctil; el scroll
    // posterior también aplaza el avance hasta que termine la inercia.
    escuchar(window, 'pointercancel', soltar, { passive: true });
    escuchar(riel, 'scroll', function () {
      anterior.disabled = riel.scrollLeft <= 2;
      siguiente.disabled = riel.scrollLeft >= maximo() - 2;
      if (Date.now() >= automaticoHasta) pausaManual();
    }, { passive: true });
    escuchar(riel, 'wheel', pausaManual, { passive: true });
    escuchar(riel, 'keydown', pausaManual);
    escuchar(riel, 'focusin', pausaManual);
    escuchar(riel, 'focusout', pausaManual);
    escuchar(document, 'visibilitychange', programar);
    escuchar(movil, 'change', function () { interactuando = false; actualizar(); programar(); });
    escuchar(movimiento, 'change', function () { pausado = movimiento.matches; actualizar(); programar(); });

    var observador = window.IntersectionObserver && new IntersectionObserver(function (entradas) {
      visible = entradas[0].isIntersecting;
      programar();
    }, { threshold: 0.15 });
    if (observador) observador.observe(seccion);
    var dimensiones = window.ResizeObserver && new ResizeObserver(function () { actualizar(); programar(); });
    if (dimensiones) dimensiones.observe(riel);
    else escuchar(window, 'resize', function () { actualizar(); programar(); });

    montadas.set(seccion, function () {
      detener();
      eventos.forEach(function (quitar) { quitar(); });
      if (observador) observador.disconnect();
      if (dimensiones) dimensiones.disconnect();
      montadas.delete(seccion);
    });
    actualizar();
    programar();
  }
  function montarTodas(raiz) {
    if (raiz.matches && raiz.matches('[data-mi-marcas-autoplay]')) montar(raiz);
    raiz.querySelectorAll('[data-mi-marcas-autoplay]').forEach(montar);
  }
  function arrancar() {
    montarTodas(document);
    // La vista previa puede reemplazar la sección sin recargar la página.
    new MutationObserver(function (cambios) {
      cambios.forEach(function (cambio) {
        cambio.addedNodes.forEach(function (nodo) {
          if (nodo.nodeType === 1) montarTodas(nodo);
        });
        cambio.removedNodes.forEach(function (nodo) {
          if (nodo.nodeType !== 1 || nodo.isConnected) return;
          var secciones = nodo.matches('[data-mi-marcas-autoplay]') ? [nodo] : nodo.querySelectorAll('[data-mi-marcas-autoplay]');
          secciones.forEach(function (seccion) {
            var desmontar = montadas.get(seccion);
            if (desmontar) desmontar();
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (evento) { montarTodas(evento.target); });
    document.addEventListener('shopify:section:unload', function (evento) {
      evento.target.querySelectorAll('[data-mi-marcas-autoplay]').forEach(function (seccion) {
        var desmontar = montadas.get(seccion);
        if (desmontar) desmontar();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  else arrancar();
})();
